import {
    GET_USUARIOS,
    ADD_USUARIO,
    UPDATE_USUARIO,
    DELETE_USUARIO,
    SET_LOADING,
    SET_ERROR
} from "./usuariosActions";

const usuariosReducer = (state, action) => {
    switch (action.type) {
        case GET_USUARIOS:
            return {
                ...state,
                usuarios: action.payload,
                loading: false
            };

        case ADD_USUARIO:
            return {
                ...state,
                usuarios: [...state.usuarios, action.payload],
                loading: false
            };

        case UPDATE_USUARIO:
            return {
                ...state,
                usuarios: state.usuarios.map(u =>
                    u._id === action.payload._id ? action.payload : u
                ),
                loading: false
            };

        case DELETE_USUARIO:
            return {
                ...state,
                usuarios: state.usuarios.filter(u => u._id !== action.payload._id),
                loading: false
            };

        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        default:
            return state;
    }
}

export default usuariosReducer;
